import { inject } from '@angular/core';
import { CanMatchFn, Route, UrlSegment, UrlTree } from '@angular/router';
import { select, Selector, Store } from '@ngrx/store';
import { filter, map, of, take, timeout } from 'rxjs';

const FLAG_RESOLVE_TIMEOUT_MS = 10_000;

export const featureFlagGuardFactory = (
  selector: Selector<object, boolean | undefined>,
  createFallbackUrl?: (route: Route, segments: UrlSegment[]) => UrlTree,
): CanMatchFn => {
  return (route, segments) => {
    const fallbackUrl = createFallbackUrl?.(route, segments) ?? false;

    return inject(Store).pipe(
      select(selector),
      filter((isEnabled) => isEnabled !== undefined),
      take(1),
      timeout({ first: FLAG_RESOLVE_TIMEOUT_MS, with: () => of(false) }),
      map((isEnabled) => (isEnabled ? true : fallbackUrl)),
    );
  };
};
